__turbopack_context__.v({
  "active": "ERdzaW_active",
  "description": "ERdzaW_description",
  "icon": "ERdzaW_icon",
  "isActionable": "ERdzaW_isActionable",
  "isDisabled": "ERdzaW_isDisabled",
  "optionsContainer": "ERdzaW_optionsContainer",
  "requiredHint": "ERdzaW_requiredHint",
  "sectionRowTitle": "ERdzaW_sectionRowTitle",
  "selectionOptions": "ERdzaW_selectionOptions",
  "selectionSectionWrapper": "ERdzaW_selectionSectionWrapper",
  "text": "ERdzaW_text",
  "title": "ERdzaW_title",
});
